/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-09-14",
    versionChannel: "nightly",
    buildDate: "2023-09-14T00:19:55.216Z",
    commitHash: "67f2d85e389feeab426abefeec22a9e8420c22ba",
};
